import { useMediaQuery } from '@mui/material'

// eslint-disable-next-line react-hooks/rules-of-hooks
export const isMobile = () => useMediaQuery('(max-width: 599px)')
// eslint-disable-next-line react-hooks/rules-of-hooks
export const isTablet = () => useMediaQuery('(min-width: 600px) and (max-width: 1000px)')
